import ActivityTeaching from './activityTeaching.js';
export default ActivityTeaching;
